import diagnostics from 'diagnostics';

//
// Keep track of the entire logging stack.
//
const loggers = {};

/**
 * Setup diagnostic logger with `util` namespace.
 *
 * @param {String} name Scope of the logger.
 * @returns {Function} diagnostics instance.
 * @api public
 */
function debug(name) {
  const logger = loggers[name] = diagnostics(`util:${name}`);

  return logger;
}

export default debug;

export {
  loggers
};
